import React from 'react';
import { GlobalFilterTypeHandle } from '../../../../context/types';
import { FilterTypes } from '../filterbar/types';
import { FilterSection } from '../types';
import { SaveDialog } from './SaveDialog';
import { DialogHandle, MyFiltersGroup } from './types';

interface EditDialogProps<T extends FilterTypes> {
  filtersHandle: GlobalFilterTypeHandle<T>;
  group: MyFiltersGroup<T>;
  dialogHandle: DialogHandle;
  setExpand: (b: boolean) => void;
  filterSections: FilterSection[];
}

export const EditDialog = <T extends FilterTypes>(
  props: EditDialogProps<T>
) => {
  return <SaveDialog<T> {...props} />;
};
